export default "__VITE_ASSET__569b7fe0__"